import React from 'react';
import { TFunction } from 'i18next';
import _get from 'lodash/get';
import Select, {
  SelectComponents,
  SelectProps,
} from '@lib/components/Select/Select';
import { FieldItem } from '@lib/interfaces/form';
import FieldNames from '@lib/enums/fieldNames/importHistoryFilterFieldNames';
import DateRangePicker from '@lib/components/DateTimePicker/DateRangePicker';
import { InputSizes, InputTypes } from '@lib/components/Input/enums';
import Button, {
  ButtonSizes,
  ButtonTypes,
} from '@lib/components/Button/Button';
import ChipControl from '@lib/components/Select/components/ChipControl';
import { ChipTypes } from '@lib/components/Chip/Chip';
import ChipMultiValueContainerForChipControl from '@lib/components/Select/components/ChipMultiValueContainerForChipControl';
import { getDataImportKindOptionsByPermission } from '@lib/utils/dataImport';
import styles from './ImportHistoryFilter.module.scss';

type Args = {
  clearFilter: () => void;
  isAssetsAvailable: boolean;
  isSitesAvailable: boolean;
  t: TFunction<'translation', undefined>;
};

export default function useFilterFields(args: Args): FieldItem[] {
  const { clearFilter, t, isSitesAvailable, isAssetsAvailable } = args;
  return [
    {
      name: FieldNames.Type,
      label: '',
      element: Select,
      componentProps: {
        isMulti: true,
        isSearchable: false,
        isClearable: false,
        options: getDataImportKindOptionsByPermission({
          isSitesAvailable,
          isAssetsAvailable,
        }),
        maxMenuHeight: 200,
        usePortal: true,
        components: {
          Control: ChipControl,
          ValueContainer: ChipMultiValueContainerForChipControl,
        } as unknown as SelectComponents,
        chipControlProps: {
          useCounter: true,
          leftIcon: 'filter_alt',
          leftIconSymbolsOutlined: true,
          type: ChipTypes.chipFilter,
          label: t('import-type'),
        },
      } as SelectProps,
      hideErrorsSpace: true,
      formItemClassName: styles.filterTypeColumn,
    },
    {
      name: FieldNames.Reset,
      customRender: (values) =>
        _get(values, [FieldNames.Type, 'length']) ? (
          <Button
            buttonSize={ButtonSizes.large}
            buttonText={t('reset')}
            buttonType={ButtonTypes.primaryText}
            onClick={clearFilter}
          />
        ) : (
          <div />
        ),
      hideErrorsSpace: true,
      formItemClassName: styles.filterResetColumn,
    },
    {
      name: FieldNames.StartedAt,
      label: t('started-on'),
      element: DateRangePicker,
      componentProps: {
        type: InputTypes.date,
        size: InputSizes.medium,
      },
      hideErrorsSpace: true,
      formItemClassName: styles.filterDateColumn,
      isOptionalFn: () => false,
    },
  ];
}
